import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Add as AddIcon, Group as GroupIcon } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { BuildingBlocksList } from 'modules/workflows/components/BuildingBlocksList'
import { BuildingBlock } from 'modules/workflows/components/WorkflowBuildingBlocksBox'
import { useHoverState } from 'modules/workflows/hooks/useHoverState'

import { NodeUIType } from './types'

type Props = {
  nodeId: string
  open: boolean
  buildingBlocks: BuildingBlock[]
  onNodeChosen: (type: NodeUIType) => void
}

export const FlowNodeAddButtonDropdown = ({
  nodeId,
  open,
  buildingBlocks,
  onNodeChosen,
}: Props) => {
  const newActionHover = useHoverState(false)
  const newMultiActionHover = useHoverState(false)

  const handleNodeChosenClick = (type: NodeUIType) => {
    onNodeChosen(type)
  }

  return (
    <Box
      id={`building-blocks-menu-${nodeId}`}
      borderRadius={{ all: 'abs012' }}
      background="white"
      flexDirection="column"
      alignItems="flexStart"
      justifyContent="center"
      position="absolute"
      border={{ all: { color: 'grey400', style: 'solid', width: 's1' } }}
      paddingY="s4"
      paddingX="s4"
      role="menu"
      aria-label="Add node options building blocks"
      style={{
        visibility: open ? 'visible' : 'hidden',
        width: '160px',
        transition: 'all 150ms ease-in-out',
        opacity: open ? '1' : '0',
        zIndex: '99',
        left: '56%',
        top: open ? '15px' : '0',
      }}
    >
      <Box flexDirection="column" alignItems="flexStart" justifyContent="center" gap="s4">
        <Box
          position="relative"
          {...newActionHover.hoverProps}
          width="full"
          style={{ alignSelf: 'flex-start' }}
        >
          <Box
            cursor="pointer"
            width="full"
            flexDirection="row"
            alignItems="center"
            gap="s4"
            paddingY="s4"
            paddingX="s6"
            borderRadius={{ all: 'abs008' }}
            role="menuitem"
            aria-haspopup="menu"
            aria-expanded={newActionHover.isHovered}
          >
            <Box
              background={newActionHover.isHovered ? 'grey200' : 'white'}
              borderRadius={{ all: 'abs006' }}
              padding="s4"
              style={{ transition: 'background-color 120ms ease-in-out' }}
            >
              <F0Icon icon={AddIcon} />
            </Box>
            <Text size="100" weight="medium" color="textPrimary">
              {i18n.t('workflows.dropdown.new_action')}
            </Text>
          </Box>
          <Box
            {...newActionHover.hoverProps}
            borderRadius={{ all: 'abs012' }}
            background="white"
            flexDirection="column"
            alignItems="flexStart"
            justifyContent="center"
            position="absolute"
            border={{ all: { color: 'grey400', style: 'solid', width: 's1' } }}
            paddingY="s4"
            paddingX="s4"
            role="menu"
            aria-label="Building blocks"
            style={{
              visibility: newActionHover.isHovered ? 'visible' : 'hidden',
              width: '160px',
              transition: 'all 150ms ease-in-out',
              opacity: newActionHover.isHovered ? '1' : '0',
              zIndex: '100',
              left: 'calc(100% + 4px)',
              top: '0',
            }}
          >
            <Box position="relative">
              <BuildingBlocksList
                blocks={buildingBlocks}
                onSelect={handleNodeChosenClick}
                showTooltip
                variant="default"
              />
            </Box>
          </Box>
        </Box>
        <Box position="relative" width="full" style={{ alignSelf: 'flex-start' }}>
          <Box
            flexDirection="row"
            alignItems="center"
            gap="s4"
            paddingY="s4"
            paddingX="s6"
            cursor="pointer"
            role="menuitem"
            borderRadius={{ all: 'abs008' }}
            {...newMultiActionHover.hoverProps}
            onClick={(event: React.MouseEvent | MouseEvent) => {
              event.stopPropagation()
              handleNodeChosenClick('multiAction')
            }}
          >
            <Box
              background={newMultiActionHover.isHovered ? 'grey200' : 'white'}
              borderRadius={{ all: 'abs006' }}
              padding="s4"
              style={{ transition: 'background-color 120ms ease-in-out' }}
            >
              <F0Icon icon={GroupIcon} />
            </Box>
            <Text size="100" weight="medium" color="textPrimary">
              {i18n.t('workflows.dropdown.new_multi_action.title')}
            </Text>
          </Box>
          <Box
            borderRadius={{ all: 'abs012' }}
            className="bg-f1-background-inverse"
            flexDirection="column"
            alignItems="flexStart"
            justifyContent="center"
            position="absolute"
            paddingY="s12"
            paddingX="s12"
            gap="s4"
            style={{
              width: '260px',
              transition: 'all 150ms ease-in-out',
              opacity: newMultiActionHover.isHovered ? '1' : '0',
              zIndex: '80',
              left: 'calc(100% + 20px)',
              top: '0',
            }}
          >
            <Box flexDirection="column" alignItems="flexStart" justifyContent="center" gap="s4">
              <Text size="100" weight="medium" className="text-f1-foreground-inverse">
                {i18n.t('workflows.dropdown.new_multi_action.tooltip.title')}
              </Text>
              <Text size="100" weight="medium" className="text-f1-foreground-inverse">
                {i18n.t('workflows.dropdown.new_multi_action.tooltip.description')}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
